import React, { useEffect, useState } from 'react';
import { Sun, Moon, Menu, X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { portfolioData } from '../mock';

const NAV = [
  { label: 'about', id: 'about' },
  { label: 'work', id: 'experience' },
  { label: 'writing', id: 'publications' },
  { label: 'skills', id: 'skills' },
  { label: 'wins', id: 'achievements' },
  { label: 'contact', id: 'contact' },
];

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'backdrop-blur-md bg-[hsl(var(--background))]/80 border-b border-[hsl(var(--rule))]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16">
          <button
            data-testid="logo-button"
            onClick={() => go('hero')}
            className="mono text-sm tracking-tight hover:text-[hsl(var(--accent))] transition-colors"
          >
            <span className="text-[hsl(var(--foreground-faint))]">~/</span>
            <span>{portfolioData.personal.name.toLowerCase().split(' ').join('-')}</span>
          </button>

          <nav className="hidden md:flex items-center gap-7">
            {NAV.map((item) => (
              <button
                key={item.id}
                data-testid={`nav-${item.id}`}
                onClick={() => go(item.id)}
                className="mono text-[0.78rem] text-[hsl(var(--foreground-muted))] hover:text-[hsl(var(--foreground))] transition-colors relative group"
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-[hsl(var(--accent))] transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="theme-toggle"
              onClick={toggleTheme}
              aria-label="Toggle theme"
              className="p-2 rounded-full border border-[hsl(var(--rule))] hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))] transition-all"
            >
              {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden p-2 rounded-full border border-[hsl(var(--rule))]"
              aria-label="Menu"
            >
              {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-5 pt-2 border-t border-[hsl(var(--rule))] mt-0">
            <div className="flex flex-col gap-2 pt-3">
              {NAV.map((item) => (
                <button
                  key={item.id}
                  data-testid={`mobile-nav-${item.id}`}
                  onClick={() => go(item.id)}
                  className="mono text-sm text-left text-[hsl(var(--foreground-muted))] hover:text-[hsl(var(--accent))] py-2"
                >
                  // {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
